export const DIALOG_CONTENT_MAX_WIDTH = '588px';
export const WIDE_DIALOG_CONTENT_MAX_WIDTH = '792px';
